import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const searchFieldStyle = css`
  margin: ${theme.spacing(2)} !important;
`;
